import { deflateSync, inflateSync, strFromU8, strToU8 } from 'fflate';

/**
 * Must stay in sync with `angular-report-designer` `shell-embed-codec.ts`.
 */
export const SHELL_EMBED_DEFLATE_PREFIX = 'z:';

function uint8ArrayToBase64(bytes: Uint8Array): string {
  let binary = '';
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}

function base64ToUint8Array(b64: string): Uint8Array {
  const binary = atob(b64);
  return Uint8Array.from(binary, c => c.charCodeAt(0));
}

export function shellEmbedEncodeDeflatedJson(
  payload: Record<string, unknown>
): string {
  const json = JSON.stringify(payload);
  const deflated = deflateSync(strToU8(json), { level: 9 });
  return SHELL_EMBED_DEFLATE_PREFIX + uint8ArrayToBase64(deflated);
}
